import { render, staticRenderFns } from "./cooperationsuccess.vue?vue&type=template&id=4d257ea0&scoped=true&"
import script from "./cooperationsuccess.vue?vue&type=script&lang=js&"
export * from "./cooperationsuccess.vue?vue&type=script&lang=js&"
import style0 from "./cooperationsuccess.vue?vue&type=style&index=0&id=4d257ea0&prod&scoped=true&lang=scss&"
import style1 from "./cooperationsuccess.vue?vue&type=style&index=1&id=4d257ea0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d257ea0",
  null
  
)

export default component.exports